/**
 * Centralized Chart.js setup
 *
 * This file registers all Chart.js components used across the application.
 * Import this file once in App.js to avoid duplicate registrations and
 * reduce bundle size.
 */

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

// Register Chart.js components globally
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  annotationPlugin
);

// Export ChartJS for cases where it's needed
export default ChartJS;
